import styled from 'styled-components';

export const Option = styled.option`
&:hover {
    border: 2px solid rgb(51, 91, 3);
    background-color: var(--primaryRgb);
}`;
